import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Holerite from 'Interface/Holerites';
import { useRemoverHoleriteMutation } from 'View/Service/Default/Holerites';

interface Props {
  dados: Holerite;
  btnRemover: boolean;
  btnAssinar: boolean;
}

const Lista = ({ dados, btnRemover = true, btnAssinar = false }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerHolerite] = useRemoverHoleriteMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerHolerite({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={
            !btnAssinar
              ? `/usuarios/editar/${dados.vinculo_empregaticio?.usuario_id}/holerites/editar/${dados.id}`
              : `/holerites/assinar/${dados.id}`
            }
          className="text-decoration-none"
        >
          {dados.mes}/{dados.ano}
        </Link>
        <small className="text-muted fs-6 d-block">
          {dados.vinculo_empregaticio?.empresa?.nome_fantasia}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            <div className="badge bg-primary">
              {dados.tipo == 1 && 'Salário'}
              {dados.tipo == 2 && 'Férias'}
              {dados.tipo == 3 && 'Rescisão'}
              {dados.tipo == 4 && 'Décimo terceiro'}
              {dados.tipo == 5 && 'PLR'}
              {dados.tipo == 6 && 'Vale/Adiantamento'}
            </div>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.assinado ? (
              <Icone nome="check-lg" className="text-success" />
            ) : (
              <Icone nome="x-lg" className="text-danger" />
            )}
            <small className="text-muted fs-6 d-block">Assinado</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.liquido.moeda()}
            <small className="text-muted fs-6 d-block">Valor</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            <small className="text-muted fs-6 d-block">Criado em</small>
          </div>
        </div>
        <div className="ms-2 fs-5 text-end">
          <Botao
            icone="cloud-download-fill"
            tema="success"
            className="ms-5"
            onClick={() => window.open(`/holerites/imprimir/${dados.id}`)}
          />{' '}
          {btnRemover && (
            <Botao
              icone="trash"
              tema="danger"
              confirmacao="Você tem certeza que deseja remover esse registro? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
